import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { axInst } from "../../../Components/Login/Service";
import { Loader } from "rsuite";
import DealerReviewTable from "../../../Components/Table/DealerReviewTable";

const volume_performance_offtake_api = async (body) => {
  try {
    const res = await axInst.post(
      "dealer-review/volume_performance_offtake",
      body
    );
    return res.data;
  } catch (error) {
    console.error("Error fetching offtake data:", error);
    throw error;
  }
};

const Volume_Performance_0fftake = () => {
  const { data, submitted } = useSelector((e) => e.filtersDealerReview);

  const {
    data: offtake_Data,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["volume_offtake", submitted],
    queryFn: () => volume_performance_offtake_api(data),
    cacheTime: 0,
    staleTime: 0,
  });

  if (isFetching)
    return (
      <div className="grid items-center justify-center w-full h-full">
        <Loader />
      </div>
    );

  if (isError) return <div>Error loading data.</div>;

  if (!offtake_Data || offtake_Data.length === 0)
    return <div className="text-center text-gray-500">Data Not Available</div>;

  return (
    <DealerReviewTable
      name={"Volume Performance Offtake"}
      data={offtake_Data}
    />
  );
};

export default Volume_Performance_0fftake;
